// Used for old Custom attributes display inside Notify User overlay
// to remove with app/assets/javascripts/react/frontoffice/components/user_targeting

const CustomizableAttribute = ({ customizableAttribute }) => {
  const attrDisplayName = customizableAttribute.display_name;
  const attrFormInputConfig = customizableAttribute.form_input_config;
  const attrId = customizableAttribute.id;
  const attrJsonOptions = customizableAttribute.json_options;
  const attrName = customizableAttribute.name;
  const attrOptions = customizableAttribute.options;
  const attrTooltip = customizableAttribute.tooltip;
  const attrType = customizableAttribute.type;
  const inputName = `query[${attrName}]`;
  const maxInputName = `query[max_${attrName}]`;
  const minInputName = `query[min_${attrName}]`;

  if (attrType === 'customizable_attribute_boolean') {
    return (
      <div
        className="push-quarter--bottom"
        data-testid="custom-attribute-boolean"
      >
        <select
          className="js-user-customizable-attribute-boolean"
          data-placeholder={attrDisplayName}
          data-toggle="tooltip"
          multiple
          name={inputName}
          title={attrTooltip}
        >
          <option key="true" value={1}>
            {I18n.t('forms.boolean.true')}
          </option>
          <option key="false" value={0}>
            {I18n.t('forms.boolean.false')}
          </option>
        </select>
      </div>
    );
  }

  if (attrType === 'customizable_attribute_number') {
    return (
      <div
        className="push-quarter--bottom"
        data-testid="custom-attribute-number"
      >
        <label className="color-gray">{attrDisplayName}</label>
        <div className="grid">
          <div className="grid__item one-half">
            <input
              className="js-auto-search"
              data-toggle="tooltip"
              name={minInputName}
              placeholder="Min"
              title={attrTooltip}
              type="number"
            />
          </div>
          <div className="grid__item one-half">
            <input
              className="js-auto-search"
              data-toggle="tooltip"
              name={maxInputName}
              placeholder="Max"
              title={attrTooltip}
              type="number"
            />
          </div>
        </div>
      </div>
    );
  }

  if (attrType === 'customizable_attribute_date') {
    return (
      <div className="push-quarter--bottom" data-testid="custom-attribute-date">
        <label className="color-gray">{attrDisplayName}</label>
        <div className="grid">
          <div className="grid__item one-half">
            <div
              className="js-user-customizable-attribute-date"
              data-toggle="tooltip"
              data-name={minInputName}
              data-placeholder="Min"
              title={attrTooltip}
            >
              <input
                data-toggle="tooltip"
                name={minInputName}
                placeholder="Min"
                title={attrTooltip}
                type="text"
              />
            </div>
          </div>
          <div className="grid__item one-half">
            <div
              className="js-user-customizable-attribute-date"
              data-toggle="tooltip"
              data-name={maxInputName}
              data-placeholder="Max"
              title={attrTooltip}
            >
              <input
                data-toggle="tooltip"
                name={maxInputName}
                placeholder="Max"
                title={attrTooltip}
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (attrType === 'customizable_attribute_select') {
    return (
      <div
        className="push-quarter--bottom"
        data-testid="custom-attribute-select"
      >
        <select
          className={`js-user-customizable-attribute-select js-user-customizable-attribute-select-${attrId}`}
          data-placeholder={attrDisplayName}
          data-toggle="tooltip"
          data-select-config={JSON.stringify(attrFormInputConfig)}
          multiple
          name={`${inputName}[]`}
          title={attrTooltip}
        >
          {attrFormInputConfig?.remote
            ? null
            : attrOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
        </select>
      </div>
    );
  }

  if (attrType === 'customizable_attribute_double_select') {
    return (
      <div
        className="push-quarter--bottom"
        data-testid="custom-attribute-double-select"
      >
        <input
          className="js-user-customizable-attribute-double-select"
          data-toggle="tooltip"
          data-double-select-options={JSON.stringify(attrJsonOptions)}
          name={inputName}
          placeholder={attrDisplayName}
          title={attrTooltip}
          type="text"
        />
      </div>
    );
  }

  return (
    <div
      className="push-quarter--bottom"
      data-testid="custom-attribute-empty"
    />
  );
};

export default CustomizableAttribute;
